<!--footer start-->
<div class="container-fluid">
    <div class="row">
        <div class="col-md-12 footer-copyright text-center">
            <p class="mb-0">Copyright {{ today | date:'y'}} © DECKorate by <a>The_Loft&#64;RRD</a>  </p>
        </div>
    </div>
</div>
<!--footer start-->